import type { DriverProfileDto } from '@posilka/shared';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

const ICON = { PENDING: '⏳', APPROVED: '✅', REJECTED: '❌', SUSPENDED: '⛔' } as const;

export function DriverStatusCard({ profile }: { profile: DriverProfileDto | null }) {
  const { t } = useTranslation();
  if (!profile) {
    return (
      <div className="card mb-4 p-6 text-center">
        <p className="mb-4 text-muted">{t('driver.notApproved')}</p>
        <Link to="/driver/apply" className="btn-primary">
          {t('profile.applyDriver')}
        </Link>
      </div>
    );
  }
  return (
    <div className="card mb-4 p-5">
      <p className="font-display font-bold">
        {ICON[profile.status]} {t(`driver.status${profile.status}`)}
      </p>
      {profile.rejectionReason && (
        <p className="mt-1 text-sm text-hint">
          {t('driver.rejectedReason', { reason: profile.rejectionReason })}
        </p>
      )}
      {profile.status === 'REJECTED' && (
        <Link to="/driver/apply" className="mt-2 inline-block text-link">
          {t('driver.reapply')} →
        </Link>
      )}
    </div>
  );
}
